import { Router } from '@angular/router';
import { AuthService } from '../auth.service';
var IsLoggedIn = /** @class */ (function () {
    function IsLoggedIn(router, authService) {
        this.router = router;
        this.authService = authService;
    }
    IsLoggedIn.prototype.resolve = function () {
        if (this.authService.token) {
            if (this.authService.roles.indexOf("administrador") > -1) {
                this.router.navigate(['dashboard/clientes']);
            }
            else if (this.authService.roles.indexOf("usuario") > -1) {
                this.router.navigate(['clientes']);
            }
            else if (this.authService.roles.indexOf("intranet") > -1) {
                this.router.navigate(['intranet/kairos']);
            }
        }
    };
    IsLoggedIn.ctorParameters = function () { return [{ type: Router }, { type: AuthService }]; };
    return IsLoggedIn;
}());
export { IsLoggedIn };
//# sourceMappingURL=is-logged-in.js.map


// WEBPACK FOOTER //
// is-logged-in.js